import React, { Component } from "react";
import { connect } from "react-redux";
import actions from "actions";
import NewsletterUsers from "components/Admin/Webinar/NewsletterUsers";
import Pagination from "components/Pagination/TablePagination";

const { loadAdminUsersWebinarsNewsletterSaga, addAdminUsersWebinars } = actions;

class NewsletterUsersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 50,
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  componentWillMount() {
    this.props.cleanAdminUsersWebinars();
  }

  getUsers = () => {
    this.props.loadAdminUsersWebinarsNewsletter(
      this.props.params.id,
      this.state.page
    );
  };

  onChangePage = (page) => this.setState({ page }, this.getUsers);

  render() {
    const { page, per_page } = this.state;
    const { users, total_pages } = this.props;

    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_webinar_users">
          <NewsletterUsers values={users} webinarId={this.props.params.id} />
          <Pagination
            page={page}
            total_pages={total_pages}
            onChangePage={this.onChangePage}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  const hasNewsletterUsers = Boolean(state.users.newsletters);

  return {
    users: hasNewsletterUsers ? state.users.newsletters.values : [],
    count: hasNewsletterUsers ? state.users.newsletters.count : 0,
    total_pages: hasNewsletterUsers ? state.users.newsletters.total_pages : 0,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadAdminUsersWebinarsNewsletter: (webinarId, page) =>
      dispatch(loadAdminUsersWebinarsNewsletterSaga(webinarId, page)),
    cleanAdminUsersWebinars: () => dispatch(addAdminUsersWebinars([])),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsletterUsersContainer);



// WEBPACK FOOTER //
// ./src/containers/Admin/Webinar/NewsletterUsersContainer.jsx